import React from 'react';
import Modal from 'react-modal';
import '../styles/css/intro.css';
import {Row, Col, Grid, Glyphicon} from 'react-bootstrap';
import EnglishFooter from '../components/EnglishFooter';
import axios from 'axios';
import p1_title from '../static/intro/p1_title.png';

import check from '../static/intro/p2_check.svg';
import p4_image1 from "../static/intro/p4_image1.jpg";
import p4_image2 from "../static/intro/p4_image2.png";
import p4_image3 from "../static/intro/p4_image3.jpg";
import p4_image4 from "../static/intro/p4_image4.jpg";
import p5_check from '../static/intro/p5_check.svg';
import p5_icon1 from '../static/intro/p5_icon1.svg';
import p5_icon2 from '../static/intro/p5_icon2.svg';
import p5_icon3 from '../static/intro/p5_icon3.svg';
import p5_icon4 from '../static/intro/p5_icon4.svg';
import p5_icon5 from '../static/intro/p5_icon5.svg';
import p5_icon6 from '../static/intro/p5_icon6.svg';
import p6_image1 from '../static/intro/p6_card1.svg';
import p6_image2 from '../static/intro/p6_card2.svg';
import p6_image3 from '../static/intro/p6_card3.svg';
import media from '../static/intro/media.png';
import partner from '../static/intro/partner.png';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    minWidth              : '300px',
    maxWidth              : '700px',
    minHeight             : '500px',
    width                 : '50%',
    zIndex                : '100'
  }
};
Modal.setAppElement('#root')

class EnglishLanding extends React.Component {

  constructor(){
    super();
    this.state = {
      modalIsOpen: false
    };
    this.smooth_scroll = this.smooth_scroll.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.send_mail = this.send_mail.bind(this);

    this.emailInput = null;
    this.contentInput = null;

    this.now_loading = false;
  }

  smooth_scroll(element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  };

  openModal() {
   this.setState({modalIsOpen: true});
 }

 afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#000000';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  send_mail(e){
    e.preventDefault();
    if(this.now_loading){
      alert('Email is sending')
      return ;
    }
    this.now_loading = true;
    axios.post('https://i98l1xafej.execute-api.ap-northeast-1.amazonaws.com/prod/email',
    {email: this.emailInput.value, content: this.contentInput.value})
    .then(response => {
      alert('Successfully Email sended')
      this.now_loading = false;
      this.setState({modalIsOpen: false})

    })
    .catch(response => {
      alert('Email send fail')
      this.now_loading = false;
    })
  }

  render(){
    return(
      <div id="intro_view">
        <section className="intro_section" id="section_p1">
          <Row>
            <Col xs={12} className="intro_p1_div text-center">
              { /*<div className="title_wrapper">
                <h1>Musio EDGE</h1>
              </div> */}
              <img alt="Musio Intro" className="title" src={p1_title}></img>
              <br/>
              <strong className="subtitle text-bold">For your exiciting future</strong><br/>
              <span className="subtitle text-light">{"We introduce you to MUSIO, the world's first AI robot for English conversation."}</span><br/>

              <button onClick={(event)=>this.smooth_scroll(document.getElementById("section_p5"))} className="plan_btn">
                <span className="span_arrow">
                  <Glyphicon glyph="menu-right" />
                </span>
                <span>
                  View Plan
                </span>
              </button><br/>
            </Col>
  					<a onClick={(event)=>this.smooth_scroll(document.getElementById("section_p2"))} className="scroll_btn"></a>
          </Row>
        </section>
        <section className="intro_section" id="section_p2">
          <Row>
            <Col xs={12} className="intro_p2_div text-center">
              <h1>
                Are you suffering from the following issues?
              </h1>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Feel nervous when speaking English in public</h1><br/>
              </div>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Have difficulty overcoming lack of motivation</h1><br/>
              </div>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Cannot speak English fluently</h1><br/>
              </div>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Cannot understand native English speakers</h1><br/>
              </div>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Do not have time to attend English institute</h1><br/>
              </div>
              <div className="check_description_div">
                <img alt="Musio Intro" src={check}></img>
                <h1>Listening to English is stressful</h1><br/>
              </div>
            </Col>
          </Row>
        </section>

        <section className="intro_section" id="section_p4">
          <Row>
            <Col xs={12} className="intro_p4_div text-center">
              <div className="p4_top">
                <h1>
                  Everyday can be thrilling with MUSIO
                </h1>
              </div>
              <div className="p4_subpage">
                <div className="p4_image_page">
                  <img alt="Musio Intro" src={p4_image1}></img>
                </div>
                <div className="p4_description_page">
                  <div>
                    <span className="des_title">
                      Living with MUSIO
                    </span>
                    <br/>
                    <span className="des_middle">
                      For once in my life,<br/>
                      I want to live with a robot.
                    </span>
                    <br/>
                    <span className="des_content">
                      With rapid technological advancement,<br />
                      it is not a dream to live with a robot anymore.<br />
                      Achieve your dream.
                    </span>
                    <br/>
                    <span className="des_middle">
                      MUSIO is keenly waiting to meet you.
                    </span>
                    <br/>
                    <span className="des_content">
                      MUSIO will become your best friend.<br />
                      Learning English with MUSIO will be fun.
                    </span>
                  </div>
                </div>
              </div>
              <div className="p4_subpage p4_page_right">
                <div className="p4_description_page">
                  <div>
                    <span className="des_title">
                      Musio Weekly Contents
                    </span>
                    <br/>
                    <span className="des_middle">
                      Hurry!<br />
                      Throw yourself to the world of Enlgish.
                    </span>
                    <br/>
                    <span className="des_content">
                    {"MUSIO Weekly Contents' aim is to make the transition to the English world comfortable."}<br />
                    It contains countless techniques to help improve your English.
                    </span>
                    <br/>
                    <span className="des_middle">
                      Take your first trip to Hawaii with MUSIO.
                    </span>
                    <br/>
                    <span className="des_content">
                      For the first year, the theme of MUSIO Weekly Contents is "Trip to Hawaii". <br />
                      These can be used to improve your English or as an actual travel guide.
                    </span>
                  </div>
                </div>
                <div className="p4_image_page p4_image_2">
                  <img alt="Musio Intro" src={p4_image2}></img>
                </div>
              </div>
            </Col>
          </Row>
        </section>
        <section className="intro_section" id="section_p4">
          <Row>
            <Col xs={12} className="intro_p4_div text-center">
              <div className="p4_top">
                <h1>
                  Enhance the quality of your study
                </h1>
              </div>
              <div className="p4_subpage">
                <div className="p4_image_page">
                  <img alt="Musio Intro" src={p4_image3}></img>
                </div>
                <div className="p4_description_page">
                  <div>
                    <span className="des_title">
                      Studying with MUSIO
                    </span>
                    <br/>
                    <span className="des_middle">
                      Improve your Confidence in English
                    </span>
                    <br/>
                    <span className="des_content">
                      Improving English skills is heavily depended on the time spent in the English speaking environment.<br />
                      Having MUSIO helps you to practice English anywhere.

                      <span className="des_content_sub">
                        Learn more about how to study using MUSIO →
                      </span>
                    </span>
                    <br/>
                    <span className="des_middle">
                      A completely new learning experience.
                    </span>
                    <br/>
                    <span className="des_content">
                      Learning with MUSIO is a totally new experience and effective. <br />
                      Through activities such as shadowing, roll-play, and quizzes, one can acquire English skills naturally.
                    </span>
                  </div>
                </div>
              </div>
              <div className="p4_subpage p4_page_right">
                <div className="p4_description_page">
                  <div>
                    <span className="des_title">
                      Support
                    </span>
                    <br/>
                    <span className="des_middle">
                      On-line English conversation once a week
                    </span>
                    <br/>
                    <span className="des_content">
                      You can test your English skills that you practiced with MUSIO.<br />
                      Online English conversation further improves your English.
                      <span className="des_content_sub">
                        Available only for MUSIO Premium
                      </span>
                    </span>
                    <br/>
                    <span className="des_middle">
                      Customer service
                    </span>
                    <br/>
                    <span className="des_content">
                      We provide help with the difficulties you encoutner studying with MUSIO.
                    </span>
                  </div>
                </div>
                <div className="p4_image_page">
                  <img alt="Musio Intro" src={p4_image4}></img>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        <section className="intro_section" id="section_p5">
          <Grid>
            <Row>
              <Col xs={12} className="intro_p5_div text-center">
                <h1>
                  Experience MUSIO just at 2 Dollars a day.
                </h1>
                <br/>
              </Col>
              <Col xsHidden smHidden sm={3} className="p5_col text-center">
                <div className="plan_icon">
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon1}></img><br/>
                      <span>Robot</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon2}></img><br/>
                      <span>AI English conversation</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon3}></img><br/>
                      <span>English learning magazine</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon4}></img><br/>
                      <span>On-line English conversation</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon6}></img><br/>
                      <span>AI learning support system</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_icon5}></img><br/>
                      <span>COURSE</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                </div>
              </Col>
              <Col xs={4} sm={4} md={3} className="p5_col text-center">
                <div className="wrapper wrapper_1">
                  <h1>
                    Normal
                    <span className="placeholder"></span>
                  </h1>
                  <p className="plan_p">
                    <span>
                      $170~<br className="hidden_br"></br>$330<span>/Month</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$90~$180</span><br/>
                      It is about 10 to 20 dollar robot<br/>
                      When used for one year
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$10~$20</span><br/>
                      For AI English conversation service
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$10~$20</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$30~$50</span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$10~$20</span><br/>
                      For AI English applications
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span className="price">$20~$40</span><br/>
                      Coffe: $5<br/>
                      When going once or twice a week
                    </span>
                    <span className="placeholder"></span>
                  </p>
                </div>
              </Col>
              <Col xs={4} sm={4} md={3} className="p5_col text-center">
                <div className="wrapper wrapper_2">
                  <h1>
                    <span className="hidden-xs">MUSIO</span> Basic
                    <span className="placeholder"></span>
                  </h1>
                  <p className="plan_p">
                    <span>
                      <span className="cancel_price">$75/Month</span><br/>
                      <span className="price">$58</span><span className="month">/Month</span><br/>
                      <span className="desc">Campaign price</span><br/>
                      <button onClick={this.openModal}>
                        To Enroll
                      </button>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( MUSIO )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( English conversation with MUSIO )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( MUSIO Weekly Teaching Materials )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <hr/>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <hr/>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <hr/>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                </div>
              </Col>
              <Col xs={4} sm={4} md={3} className="p5_col text-center">
                <div className="wrapper wrapper_3">
                  <h1>
                    <span className="hidden-xs">MUSIO</span> Premium
                    <span className="placeholder"></span>
                  </h1>
                  <p className="plan_p">
                    <span>
                      <span className="cancel_price">$98/Month</span><br/>
                      <span className="price">$78</span><span className="month">/Month</span><br/>
                      <span className="desc">Campaign price</span><br/>
                      <button onClick={this.openModal}>
                        To Enroll
                      </button>

                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( MUSIO )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( English conversation with MUSIO )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <img alt="Musio Intro" src={p5_check}></img><br/>
                      <span className="edge_desc">( MUSIO Weekly Teaching Materials )</span><br/>
                        Get even more
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span>
                        <img alt="Musio Intro" src={p5_check}></img><br/>
                        <span className="edge_desc">( On-line English conversation of our partnership 4 times a month )</span><br/>
                          Get even more
                      </span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span>
                        <img alt="Musio Intro" src={p5_check}></img><br/>
                        <span className="edge_desc">{"( AI Coaching function )"}</span><br/>
                          Get even more
                      </span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                  <p>
                    <span>
                      <span>
                        <img alt="Musio Intro" src={p5_check}></img><br/>
                        <span className="edge_desc">( At any time, no fee )</span><br/>
                          Get even more
                      </span>
                    </span>
                    <span className="placeholder"></span>
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <hr/>
                <h1>Robot</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$90~$180</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <h1>AI English conversation</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$10~$20</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <h1>English learning magazine</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$10~$20</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <h1>On-line English conversation</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$30~$50</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <hr/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <h1>AI learning support system</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$10~$20</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <hr/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={12} sm={12} className="p5_col text-center visible-xs visible-sm mobile_plan">
                <h1>COURSE</h1>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_1">
                <p>
                  <span>
                    <span>$20~$40</span>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_2">
                <p>
                  <span>
                    <hr/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>
              <Col xs={4} sm={4} className="p5_col text-center visible-xs visible-sm m_plan_box mobile_box_3">
                <p>
                  <span>
                    <img alt="Musio Intro" src={p5_check}></img><br/>
                  </span>
                  <span className="placeholder"></span>
                </p>
              </Col>

            </Row>
          </Grid>
        </section>
        <section className="intro_section" id="section_p6">
          <Grid className="text-center">
            <Row>
              <Col xs={12} className="intro_p6_div text-center">
                <h1>
                  Voice of Customer
                </h1>
              </Col>
              <Col xs={12} sm={4} className="p6_card text-center">
                <div className="card_wrapper">
                  <div className="card_image">
                    <img alt="Musio Intro" src={p6_image1}></img>
                  </div>
                  <div className="card_content">
                    <span className="name">27-year-old female</span><br/>
                    "The Weekly MUSIO Content is classy. The workload is just right and I really enjoy studying with it each week!"
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={4} className="p6_card text-center">
                <div className="card_wrapper">
                  <div className="card_image">
                    <img alt="Musio Intro" src={p6_image2}></img>
                  </div>
                  <div className="card_content">
                    <span className="name">22-year-old female</span><br/>
                    "I have tried numerous ways to study English but studying with MUSIO is the most enjoyable! I am also happy with other cool features that MUSIO offers!"
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={4} className="p6_card text-center">
                <div className="card_wrapper">
                  <div className="card_image">
                    <img alt="Musio Intro" src={p6_image3}></img>
                  </div>
                  <div className="card_content">
                    <span className="name">33-year-old female</span><br/>
                    "Interacting with MUSIO is so wonderful that it motivates me to study English more."
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>


        <section className="intro_section" id="section_p9">
          <Grid className="text-center">
            <Row>
              <Col xs={12} className="intro_p9_div text-center">
                <h1>
                  Media
                </h1>
                <img alt="Musio Intro" src={media}></img>
                <h1 className="title_2">
                  PARTNER
                </h1>
                <img alt="Musio Intro" src={partner}></img>
              </Col>
            </Row>
          </Grid>
        </section>
        <EnglishFooter />
              <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Example Modal"
              >

                <h2 ref={subtitle => this.subtitle = subtitle}>Support</h2>
                <form onSubmit={this.send_mail}>
                  <Row className="modal_content_wrapper">
                    <Col xs={12}>
                      <input className="modal_email" type="email" name="email" placeholder="Input your email address"
                      ref={(input) => {this.emailInput = input}} required />
                    </Col>
                    <Col xs={12}>
                      <textarea className="modal_content" type="textarea" rows='16' name="content" placeholder="Input content that you want to send us"
                      ref={(input) => {this.contentInput = input}} required />
                    </Col>
                    <Col xs={12}>
                      <button type="submit" className="modal_submit">
                        Send
                      </button>
                    </Col>
                  </Row>
                </form>
              </Modal>
      </div>

    );

  }
};

export default EnglishLanding;



// WEBPACK FOOTER //
// ./src/components/EnglishLanding.js